import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"logo",style:(_setup.vuetify.breakpoint.mdAndDown || _vm.mini
      ? _vm.logoMarginSM
      : '' || _setup.vuetify.breakpoint.mdOnly
        ? _vm.logoMarginMD
        : '' || _setup.vuetify.breakpoint.lgOnly
          ? _vm.logoMarginLG
          : '' || _setup.vuetify.breakpoint.xlOnly
            ? _vm.logoMarginXL
            : '')},[(!_vm.loading)?_c('div',[(_setup.vuetify.breakpoint.mdAndDown || _vm.mini)?_c(VImg,{attrs:{"contain":"","max-width":_vm.logoSmallWidth,"max-height":_vm.logoSmallHeight,"src":_setup.errorDownloadingSmallImage ? _vm.altLogoSmall : _vm.logoSmall},on:{"error":function($event){_setup.errorDownloadingSmallImage = true}}}):_c(VImg,{attrs:{"contain":"","max-width":_vm.logoBigWidth,"max-height":_vm.logoBigHeight,"src":_setup.errorDownloadingBigImage ? _vm.altLogoBig : _vm.logoBig},on:{"error":function($event){_setup.errorDownloadingBigImage = true}}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }